import { BeachElementImages, BeachElementType } from '../jotai-modules/types'
import {
  availableCabana,
  unavailableCabana,
  selectedCabana,
  availableUmbrella,
  unavailableUmbrella,
  selectedUmbrella,
  availablePouf,
  unavailablePouf,
  selectedPouf,
  bar,
  lifeGuard,
  shower,
  wc,
  runwayHorizontal,
  runwayVertical,
  changeRoom,
  runwayTLeft,
  runwayTTop,
  runwayTRight,
  runwayTBottom,
  runwayCross,
  disabledUmbrella,
  disabledCabana,
  disabledPouf,
  jetski,
  windsurf,
} from '../components/assets'

export const BEACH_PLAN_HEIGHT = { desktop: '700px', mobile: '670px' }

export const BEACH_PLAN_ELEMENTS: Partial<Record<BeachElementType, BeachElementImages>> = {
  [BeachElementType.CABANA]: {
    image: availableCabana,
    selectedImage: selectedCabana,
    unavailableImage: unavailableCabana,
    disabledImage: disabledCabana,
  },
  [BeachElementType.UMBRELLA]: {
    image: availableUmbrella,
    selectedImage: selectedUmbrella,
    unavailableImage: unavailableUmbrella,
    disabledImage: disabledUmbrella,
  },
  [BeachElementType.POUF]: { image: availablePouf, selectedImage: selectedPouf, unavailableImage: unavailablePouf, disabledImage: disabledPouf },
  [BeachElementType.RUNWAY_HORIZONTAL]: {
    image: runwayHorizontal,
    selectedImage: runwayHorizontal,
    unavailableImage: runwayHorizontal,
    disabledImage: runwayHorizontal,
  },
  [BeachElementType.RUNWAY_VERTICAL]: {
    image: runwayVertical,
    selectedImage: runwayVertical,
    unavailableImage: runwayVertical,
    disabledImage: runwayVertical,
  },
  [BeachElementType.RUNWAY_T_LEFT]: { image: runwayTLeft, selectedImage: runwayTLeft, unavailableImage: runwayTLeft, disabledImage: runwayTLeft },
  [BeachElementType.RUNWAY_T_TOP]: { image: runwayTTop, selectedImage: runwayTTop, unavailableImage: runwayTTop, disabledImage: runwayTTop },
  [BeachElementType.RUNWAY_T_RIGHT]: {
    image: runwayTRight,
    selectedImage: runwayTRight,
    unavailableImage: runwayTRight,
    disabledImage: runwayTRight,
  },
  [BeachElementType.RUNWAY_T_BOTTOM]: {
    image: runwayTBottom,
    selectedImage: runwayTBottom,
    unavailableImage: runwayTBottom,
    disabledImage: runwayTBottom,
  },
  [BeachElementType.RUNWAY_CROSS]: { image: runwayCross, selectedImage: runwayCross, unavailableImage: runwayCross, disabledImage: runwayCross },
  [BeachElementType.SHOWER]: { image: shower, selectedImage: shower, unavailableImage: shower, disabledImage: shower },
  [BeachElementType.WC]: { image: wc, selectedImage: wc, unavailableImage: wc, disabledImage: wc },
  [BeachElementType.BAR]: { image: bar, selectedImage: bar, unavailableImage: bar, disabledImage: bar },
  [BeachElementType.LIFE_GUARD]: { image: lifeGuard, selectedImage: lifeGuard, unavailableImage: lifeGuard, disabledImage: lifeGuard },
  [BeachElementType.CHANGE_ROOM]: { image: changeRoom, selectedImage: changeRoom, unavailableImage: changeRoom, disabledImage: changeRoom },
  [BeachElementType.JET_SKI]: { image: jetski, selectedImage: jetski, unavailableImage: jetski, disabledImage: jetski },
  [BeachElementType.WINDSURF]: { image: windsurf, selectedImage: windsurf, unavailableImage: windsurf, disabledImage: windsurf },
}
